import { useState } from 'react';
import logger from '../../../utils/logger';
import { getVersionViewData } from '../../../api/api';
import { MarkerType } from '@xyflow/react';
import CustomAlert from '../../../components/CustomAlert';

export const useMapLevelVersionData = ({
  processId,
  level,
  version,
  currentParentId,
  setNodes,
  setEdges,
  setSupportedLanguages,
  setprocessDefaultlanguage_id,
  setOriginalDefaultlanguge_id,
  Settitle,
}) => {
  const [contactInfo, setContactInfo] = useState(null);
  const [revisionInfo, setRevisionInfo] = useState(null);
  const [assignedUsers, setAssignedUsers] = useState([]);
  const [versionStatus, setVersionStatus] = useState(null);
  const [versionDate, setVersionDate] = useState(null);
  const [processImg, setProcessImg] = useState(null);
  const [versionTitle, setVersionTitle] = useState('');

  const fetchVersionData = async (language_id = null) => {
    try {
      const response = await getVersionViewData(
        processId,
        level,
        version,
        'ProcessMap',
        currentParentId,
        language_id
      );
      const {
        nodes: rawNodes,
        edges: rawEdges,
        title: modelTitle,
        processDefaultlanguage_id: pLang,
        supportedLanguages: rawSupportedLanguages,
        OriginalDefaultlanguge_id,
        contact_info,
        revision_info,
        assigned_users,
      } = response;

      setSupportedLanguages(rawSupportedLanguages || []);
      setprocessDefaultlanguage_id(pLang);
      setOriginalDefaultlanguge_id(OriginalDefaultlanguge_id);

      setContactInfo(contact_info);
      setRevisionInfo(revision_info);
      setAssignedUsers(assigned_users || []);
      setVersionStatus(response.status);
      setVersionDate(response.created_at);
      setProcessImg(response.Process_img);

      const vName = rawNodes[0]?.version || '';
      setVersionTitle(vName);
      Settitle(modelTitle);

      const parsedNodes = rawNodes.map((node) => {
        const parsedMeasured = node.measured ? JSON.parse(node.measured) : undefined;
        return {
          ...node,
          data: {
            ...JSON.parse(node.data),
            width_height: parsedMeasured,
          },
          id: node.node_id,
          measured: parsedMeasured,
          position: JSON.parse(node.position),
          draggable: false,
        };
      });

      const parsedEdges = rawEdges.map((edge) => {
        let parsedData = {};
        if (edge.data) {
          try {
            parsedData = typeof edge.data === 'string' ? JSON.parse(edge.data) : edge.data;
          } catch (e) {
            logger.error('Error parsing edge data', e);
          }
        }

        return {
          ...edge,
          id: edge.edge_id || edge.id,
          source: edge.source,
          target: edge.target,
          animated: Boolean(edge.animated),
          markerEnd: {
            type: MarkerType.ArrowClosed,
            color: '#002060',
            width: 12,
            height: 12,
          },
          style: { stroke: '#002060', strokeWidth: 2 },
          type: edge.type && !edge.type.startsWith('{') ? edge.type : 'step',
          data: parsedData,
        };
      });

      setNodes(parsedNodes);
      setEdges(parsedEdges);
    } catch (error) {
      logger.error('Error fetching version data:', error);
      CustomAlert.error('Error', 'Error fetching versioned data');
    }
  };

  const handleLanguageSwitch = (langId) => {
    setprocessDefaultlanguage_id(langId);
    fetchVersionData(langId);
  };

  return {
    contactInfo,
    revisionInfo,
    assignedUsers,
    versionStatus,
    versionDate,
    processImg,
    versionTitle,
    fetchVersionData,
    handleLanguageSwitch,
  };
};
